import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadAssignmentService {
  public baseUrl = environment.apiUrl;
  constructor(public httpClient: HttpClient,) { }

  public isOpenAddRule = new BehaviorSubject(null);
  public isOpenListAutomationRule = new BehaviorSubject(null);
  public isOpenDrawer = new BehaviorSubject(null);
  public SelectedRuleId = new BehaviorSubject(null);
  public titleSource = new BehaviorSubject<string>(''); // Default title
  currentTitle = this.titleSource.asObservable();
  public headerSource = new BehaviorSubject<string>('Lead Assignment'); // Default header
  currentHeader = this.headerSource.asObservable();

  openAddRule(data:any) {
    this.isOpenAddRule.next(data);
    }

    OpenListAutomationRules(data:any) {
      this.isOpenListAutomationRule.next(data);
    }

    openDrawer(data:any) { 
      this.isOpenDrawer.next(data);
    }

    SelectRuleId(data:any) {
      this.SelectedRuleId.next(data);
    }

    getModuleField(ModuleId:any, selectedAutomationType:any) {
      return this.httpClient.get(this.baseUrl + `Automation/GetModuleFields/${ModuleId}?isRotation=${selectedAutomationType}`);
    }

  getModuleFieldOperators() {
    return this.httpClient.get(this.baseUrl + `Automation/GetModuleFieldOperators`);
  }

  getTeams(companyId:any) {
    return this.httpClient.get(this.baseUrl + `Teams/GetTeamsByCompany/${companyId}`);
  }

  getUsers(companyId:any) {
    return this.httpClient.get(this.baseUrl + `User/GetUsersByCompanyIdAsync/${companyId}`);
  }

  getModuleFilterCondtions(moduleId:any) {
    return this.httpClient.get(this.baseUrl + `Automation/GetModuleFilterCondtion/${moduleId}`);
  }

  InsertAutomationRule(data: any) {
    return this.httpClient.post(
      this.baseUrl + `Automation/InsertAutomationRule`,
      data
    );
  }

  UpdateAuotmationRule(data:any) {
    return this.httpClient.post(
      this.baseUrl + `Automation/UpdateAutomationRule`,
      data
    );
  }

  saveColumnOrder(data:any) {
    return this.httpClient.post(
      this.baseUrl + `User/SaveColumns`,
      data
    );
  }

  
  getColumnOrder(userId:any,table:any) {
    return this.httpClient.get(this.baseUrl + `User/GetColumns/${userId}/${table}`);
  }

  GetAutomationRules(data:any) {
    return this.httpClient.post(
      this.baseUrl + `Automation/GetAutomationRules`,
      data
    );
  }  

  SaveAutomationRuleSequnce(data:any) {
    return this.httpClient.post(
      this.baseUrl + `Automation/SaveAutomationRuleSequnce`,
      data
    );
  }

  GetAutomationRuleById(id:any) {
    return this.httpClient.get(this.baseUrl + `Automation/GetAutomationRuleDetailById/${id}`);
  }

  getModuleList() {
    return this.httpClient.get(this.baseUrl + `Automation/GetModuleList`);
  }

  getTriggerList() {
    return this.httpClient.get(this.baseUrl + `Automation/GetTriggerList`);
  }

  getEventList(id:any) {
    return this.httpClient.get(this.baseUrl + `Automation/GetEventList/${id}`);
  }
  updateTitle(newTitle: string) {
    this.titleSource.next(newTitle);
  }
  updateHeader(newHeader: string) {
    this.headerSource.next(newHeader); // Update header menu
  }
  getCampaignList(companyId: any, name: any) {
    return this.httpClient.get(`${this.baseUrl}Automation/GetAllCampaign?CompanyId=${companyId}&name=${name}`);
  }
}
